import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  fill: "none",
  height: "24",
  viewBox: "0 0 24 24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      "clip-rule": "evenodd",
      d: "m15.5303 5.46967c.2929.29289.2929.76777 0 1.06066l-5.4696 5.46967 5.4696 5.4697c.2929.2929.2929.7677 0 1.0606s-.7677.2929-1.0606 0l-6.00003-6c-.29289-.2929-.29289-.7677 0-1.0606l6.00003-6.00003c.2929-.29289.7677-.29289 1.0606 0z",
      fill: "currentColor",
      "fill-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }